<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <v-card class="pa-3">
      <v-card-title class="primary elevation-4">
        <span class="headline white--text">
          {{ isEdit ? 'Update' : 'Create' }} NBN Hardware
        </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md4>
              <ValidationProvider
                name="hardwareName"
                rules="required"
                immediate
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Hardware Name"
                  name="hardwareName"
                  :error-messages="errors"
                  v-model="item.hardwareName"
                  @change="onChange()"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <ValidationProvider
                name="contractLength"
                rules="required"
                immediate
                v-slot="{ errors }"
              >
                <v-select
                  :items="months"
                  v-model="item.contractLength"
                  label="Contract Length"
                  :error-messages="errors"
                  name="contractLength"
                  @change="onChange()"
                ></v-select>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <ValidationProvider
                name="usageType"
                rules="required"
                immediate
                v-slot="{ errors }"
              >
                <v-combobox
                  v-model="item.usageType"
                  :items="type"
                  label="Usage Type"
                  readonly
                  :error-messages="errors"
                  @change="onChange()"
                ></v-combobox>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <ValidationProvider name="detail" immediate v-slot="{ errors }">
                <v-text-field
                  label="Detail"
                  name="detail"
                  :error-messages="errors"
                  v-model="item.detail"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>

            <v-flex xs12 sm6 md4>
              <ValidationProvider
                name="rrp"
                rules="required|max_value:100000000.00"
                immediate
                v-slot="{ errors }"
              >
                <v-text-field
                  label="RRP"
                  name="rrp"
                  prefix="$"
                  :error-messages="errors"
                  @change="onChange()"
                  v-model="item.rrp"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save" :disabled="invalid">Save</v-btn>
        <v-btn color="light-grey" @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </ValidationObserver>
</template>

<script>
import { NBNHardware } from '@/models/NbnHardware';

export default {
  name: 'UpsertNBNHardware',
  data() {
    return {
      item: new NBNHardware(),
      months: ['0', '12', '24', '36'],
      type: ['nbn', 'nbnEnterprise'],
      disable: false,
    };
  },
  props: {
    isEdit: { type: Boolean, required: true },
    hardware: { required: true },
  },
  watch: {
    hardware: {
      immediate: true, // This ensures the watcher runs immediately when the component is created
      handler(newHardware) {
        if (this.isEdit) {
          this.item = { ...newHardware };
        }
      },
    },
  },
  methods: {
    cancel() {
      this.item = new NBNHardware();
      this.$emit('close');
    },
    save() {
      this.$emit('save', this.item);
      this.item = new NBNHardware();
    },
    onChange() {
      let vm = this;

      vm.$refs.observer.validate().then(result => {
        if (!result) vm.disable = true;
        else vm.disable = false;
      });
    },
  },
};
</script>
